import { createRouter, createWebHashHistory } from "vue-router"

import IntroPage from '@/pages/IntroPage.vue'
import HomePage from '@/pages/HomePage.vue'
import PosterPage from '@/pages/PosterPage.vue'
import ShowPosterPage from '@/pages/ShowPosterPage.vue'
import GenerateTrailerPage from '@/pages/GenerateTrailerPage.vue'
import ShowTrailerPage from '@/pages/ShowTrailerPage.vue'

const Router = createRouter({
  history: createWebHashHistory(),
  routes: [
    { 
      name: 'Intro',
      path: '/', 
      component: IntroPage,
    },
    {
      name: 'Home',
      path: '/home',
      component: HomePage
    },
    {
      name: 'Poster',
      path: '/poster',
      component: PosterPage
    },
    {
      name: 'ShowPoster',
      path: '/show-poster',
      component: ShowPosterPage
    },
    {
      name: 'GenerateTrailer',
      path: '/generate-trailer',
      component: GenerateTrailerPage
    },
    {
      name: 'ShowTrailer',
      path: '/show-trailer',
      component: ShowTrailerPage
    },
    {
      name: '404',
      path: '/:pathMatch(.*)*',
      component: IntroPage
    }
  ],
})

export default Router;